var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg100RemoveGray(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#474749"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0255 12.0588C21.3249 11.7594 21.3249 11.2739 21.0255 10.9745C20.7261 10.6752 20.2406 10.6752 19.9412 10.9745L16 14.9158L12.0588 10.9745C11.7594 10.6752 11.2739 10.6752 10.9745 10.9745C10.6752 11.2739 10.6752 11.7594 10.9745 12.0588L14.9158 16L10.9745 19.9412C10.6752 20.2406 10.6752 20.7261 10.9745 21.0255C11.2739 21.3249 11.7594 21.3248 12.0588 21.0255L16 17.0842L19.9412 21.0255C20.2406 21.3248 20.7261 21.3249 21.0255 21.0255C21.3249 20.7261 21.3249 20.2406 21.0255 19.9412L17.0842 16L21.0255 12.0588Z",
    fill: "#E0E0E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg100RemoveGray);
export default __webpack_public_path__ + "static/media/100-remove-gray.fc9cd1a030b002ae8743e76191812c60.svg";
export { ForwardRef as ReactComponent };